import React, { useState, useEffect } from 'react';
// import React from 'react';
import './QualityStartsWithYou.scss';
import ClickableItem from './ClickableItem';
import Activity from './Activity';
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';
import Button from '../../partials/Button';

const QualityStartsWithYou = (props) => {
 
  const segment = props.data;

  const  { onComplete } = props;

  const [activityDisplayIndex, setActivityDisplayIndex] = useState(null);

  const [visitedActivities, setVisitedActivities] = useState(segment.activities.map((x, i) => i == activityDisplayIndex));

  const progress =  visitedActivities.filter(x => x).length / visitedActivities.length;
  console.log('visited activities', visitedActivities,progress);
  console.log(visitedActivities.indexOf(false) >= 0)

  const onVisited = (i) => {
      setActivityDisplayIndex(() => activityDisplayIndex === i ? false : i);
      visitedActivities[i] = true;
      setVisitedActivities(visitedActivities);
  }

  const activity = segment.activities[activityDisplayIndex];

  //console.log('segment', segment)

  const textBox = (activityIndex) => {
    return segment.activities[activityIndex] && <div 
      key={segment.activities[activityIndex].key}
      className={`click-text ${false ? 'highlighted' : ''} activity-${segment.activities[activityIndex].activity}`} 
      onClick={() => onVisited(activityIndex)}
      dangerouslySetInnerHTML={{ __html: segment.activities[activityIndex].preview}}
      />
  };
  
  return (
    <>

<InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
      <div className="quality-starts-with-you">
        <div className="back-btn-container">
            <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
        </div>
        <h2 className="instructions" dangerouslySetInnerHTML={{__html: segment.instruction}} />
        {(() => {
          if (segment.layout === '2-column') {
            return <>
              
              {/* <h2 className="instructions">{segment.instructions}</h2> */}
              <div className="two-column">
                <div className="click-left-container">
                  <div className="quad-container" style={{ backgroundImage: `url(${segment.backgroundImage})` }}>
                    {segment.activities.map((item, index) => (
                      <div className="quad" key={index}>
                        <ClickableItem index={index} curved={true} onClick={() => onVisited(index)} text={item.title} />
                      </div>
                    ))
                    }
                  </div>
                  {/* <div className="center-slice">
                        {segment.header}
                      </div> */}
                </div>
                <div className="click-right-container">
                {activity
                  ? <Activity className={activity.className} title={activity.title} content={activity.content} />
                  : <Activity className="overview" title="Overview" content={segment.overview} />
                }
                </div>
              </div>
            </>
          } else if (segment.layout === '3-column') {
            return <div className="three-column">
              <div className="click-left-container">
                  {activityDisplayIndex === 0 || activityDisplayIndex === 2
                    ? <Activity className={activity.className} title={activity.title} content={activity.content} />
                    : <div className='placeholder'></div>
                  }
              </div>

              <div className="click-center-container">
                {/* <h2 className="instructions">{segment.instructions}</h2> */}
                <div className="wheel-holder">
                  <div className="quad-container" style={{ backgroundImage: `url(${segment.backgroundImage})` }}>
                    {segment.activities.map((item, index) => (
                      <div className="quad" key={index}>
                        <ClickableItem index={index} curved={true} onClick={() => onVisited(index)} text={item.title} />
                      </div>
                    ))
                    }
                  </div>
                  {/* <div className="center-slice">
        {segment.header}
      </div> */}
                </div>
              </div>

              <div className="click-right-container">
                  {activityDisplayIndex === 1 || activityDisplayIndex === 3
                    ? <Activity className={activity.className} title={activity.title} content={activity.content} />
                    : <div className="placeholder"> </div>
                  }
              </div>


            </div>
          } else if (segment.layout === 'text') {
            //  const activityFlexJustify = [
            //    'flex-start',
            //    'flex-start',
            //    'center',
            //    'center',
            //    'flex-end',
            //    'flex-end'
            //  ];
            return <div className="text-layout">
              {/* <h2 className="instructions">{segment.instruction}</h2> */}
              {/* <div className="left-content-container" style={{justifyContent: activityFlexJustify[activityDisplayIndex]}}> */}
              <div className="left-content-container">
                {activityDisplayIndex === 0 || activityDisplayIndex === 2 || activityDisplayIndex === 4
                    ? <Activity className={`${activity.className || ''} activity-${activity.activity}`} title={activity.title} content={activity.content} />
                    : <div className="placeholder"> </div>
                }
              </div>

              <div className="options-container">
                <div className="click-text-row">
                  {textBox(0)}
                  {textBox(1)}
                </div>
                <div className="click-text-row">
                  {textBox(2)}
                  {/* <div className={`click-text`}> 
                    {segment.overview}
                  </div> */}
                  {textBox(3)}
                </div>
                <div className="click-text-row">
                  {textBox(4)}
                  {textBox(5)}
                </div>
              
              </div>

              {/* <div className="right-content-container" style={{justifyContent: activityFlexJustify[activityDisplayIndex]}}> */}
              <div className="right-content-container">
                {activityDisplayIndex === 1 || activityDisplayIndex === 3 || activityDisplayIndex === 5
                    ? <Activity className={`${activity.className} activity-${activity.activity}`} title={activity.title} content={activity.content} />
                    : <div className="placeholder"> </div>
                }   
              </div>
            </div>
          }
        })()}
        <div className='progress-container'>
          <Button variant="toRight" text="Next" disabled={visitedActivities.indexOf(false) >= 0} onClick={onComplete} />
        </div>
      </div>
      </InteractionContainer>
    </>
  );

};

export default QualityStartsWithYou;